import apiClient from '@/services/axios'
// import _ from 'lodash'
// import moment from 'moment'

const actions = {
  async GETSALESORDERS({ commit, rootState, dispatch }, {
    page = 1,
    limit = 20,
    from,
    to,
    q,
    order_state,
    channel_id,
  }) {
    try {
      // const { page = 1, limit = 20, from = '', to = '', q = '', order_state } = payload
      commit('SET_LOADING_TABLE', true)
      commit('SET_TABLE_ACTIVE', 'all_status')
      const { data: response } = await apiClient({
        method: 'get',
        url: '/orders/private',
        params: {
          page,
          limit,
          from,
          to,
          q,
          order_state,
          channel_id,
        },
      })
      const pagination = { ...rootState.salesOrders.pagination }
      pagination.total = response.total_record
      pagination.pageSize = limit
      commit('SET_PAGINATION', pagination)
      commit('SET_SALES_ORDERS', response.data)
    } catch (e) {
      console.log(e)
    } finally {
      commit('SET_LOADING_TABLE', false)
    }
  },

  async GETORDERDETAIL ({ commit, rootState }, payload) {
    try {
      const options = {
        method: 'get',
        url: `/orders/private/${payload}`,
      }
      const response = await apiClient(options)
      commit('SET_ORDER_DETAIL', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default actions
